import { BrakeConditionSelect } from './brake-condition-select';
import { BrakeWearPercentSelect } from './brake-wear-percent-select';
import { VhcRecordBaseElements } from './components/base-elements';
import { VhcRecordDescription } from './description';
import { VHCRecordCheckBrakeItemTypes } from 'api/generated';
import { useVhcStore } from 'features/vhc/model/vhc-store';
import { Col, Form, Row } from 'react-bootstrap';

export const VhcRecordBreakForm = () => {
  const { recordModalData } = useVhcStore();
  const breakType = recordModalData?.data.type;

  return (
    <div className="ok-form">
      <Row>
        <Col md={12} className="d-flex flex-column gap-6">
          <VhcRecordDescription />
          <Form.Group className="mb-3">
            <Form.Label className="d-block d-lg-none fs-7 mb-2">
              {breakType === VHCRecordCheckBrakeItemTypes.FrontPadsAndDiscs
                ? 'Front Brake Pads remain, %'
                : 'Rear Brake Pads remain, %'}
            </Form.Label>

            <div className="row align-items-center">
              <Form.Label className="col-lg-3 d-none d-lg-block fs-7 required text-nowrap">
                {breakType === VHCRecordCheckBrakeItemTypes.FrontPadsAndDiscs
                  ? 'Front Brake Pads remain, %'
                  : 'Rear Brake Pads remain, %'}
              </Form.Label>

              <div className="col-12 col-lg-9">
                <BrakeWearPercentSelect />
              </div>
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="d-block d-lg-none fs-7 mb-2">
              {breakType === VHCRecordCheckBrakeItemTypes.FrontPadsAndDiscs
                ? 'Front Brake Discs Condition'
                : 'Rear Brake Discs Condition'}
            </Form.Label>

            <div className="row align-items-center">
              <Form.Label className="col-lg-3 d-none d-lg-block fs-7 required text-nowrap">
                {breakType === VHCRecordCheckBrakeItemTypes.FrontPadsAndDiscs
                  ? 'Front Brake Discs Condition'
                  : 'Rear Brake Discs Condition'}
              </Form.Label>

              <div className="col-12 col-lg-9">
                <BrakeConditionSelect />
              </div>
            </div>
          </Form.Group>
          <VhcRecordBaseElements />
        </Col>
      </Row>
    </div>
  );
};
